import { tv, type VariantProps } from "tailwind-variants";

export const switchImageVariant = tv({
  slots: {
    base: ["flex", "flex-col", "gap-3", "w-full"],
    header: ["flex", "flex-col", "gap-3"],
    title: ["text-text-neutral-default"],
    description: ["text-text-neutral-soft"],
    content: ["flex", "flex-col", "gap-3"],
    mediaWrapper: ["relative", "w-full", "rounded-2xl", "overflow-hidden"],
    media: ["w-full", "h-full", "object-cover"],
  },
  variants: {},
  defaultVariants: {},
});

export type SwitchImageVariantProps = VariantProps<typeof switchImageVariant>;
export type SwitchImageReturnVariantProps = ReturnType<typeof switchImageVariant>;
